import { useNavigate, useParams } from "react-router-dom";
import { RecordDetails } from "@/features/patient/records/components/RecordDetails";
import { usePatientData } from "@/portals/patient/context/PatientDataContext";

export function RecordDetailsPage() {
  const navigate = useNavigate();
  const { recordId } = useParams();
  const { records, selectedRecord, setSelectedRecord } = usePatientData();

  const record =
    selectedRecord?.id === recordId
      ? selectedRecord
      : records.find((r) => r.id === recordId) ?? null;

  return (
    <RecordDetails
      record={record}
      onBack={() => {
        setSelectedRecord(null);
        navigate("/patient");
      }}
    />
  );
}
